import { createSelector } from 'reselect';

const selectWebsiteCards = (state: any) => state.websiteCards;


export const selectWebsiteCardsCurrentItem = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.current);

export const selectWebsiteCardsListItems = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectWebsiteCardsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectWebsiteCardsQueryItems = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.query);

export const selectWebsiteCardsCreatedItem = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.create);

export const selectWebsiteCardsUpdatedItem = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.update);

export const selectWebsiteCardsReadItem = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.read);

export const selectWebsiteCardsDeletedItem = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.delete);

export const selectWebsiteCardsSearchedItems = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.search);

export const selectWebsiteCardsItemsCount = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.count);

export const selectWebsiteCardsItemsFilter = createSelector([selectWebsiteCards], (websiteCards) => websiteCards.filter);